export default function CustomerImportBatchStatusBadge({ status }) {
  const key = String(status || "").toLowerCase();
  const cls = key === "completed"
    ? "bg-emerald-100 text-emerald-700"
    : key === "completed_with_errors"
      ? "bg-amber-100 text-amber-700"
      : key === "processing"
        ? "bg-blue-100 text-blue-700"
        : "bg-rose-100 text-rose-700";

  const label = key === "completed"
    ? "Voltooid"
    : key === "completed_with_errors"
      ? "Voltooid met fouten"
      : key === "processing"
        ? "Verwerken"
        : "Mislukt";

  return <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${cls}`}>{label}</span>;
}
